module.exports = __webpack_public_path__ + "static/media/unifi-logo.bc6097fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/unifi-logo.svg
// module id = 2154
// module chunks = 0